import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  useEffect(() => { api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser((u) => (u === null ? false : u))); }, []);
  const login = async (email, password) => { const { data } = await api.post("/auth/login", { email, password }); setUser(data); return data; };
  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };
  return <AuthContext.Provider value={{ user, login, logout, isOwner: user && user.role === "titolare" }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
